.table {
  flex: 1;
  padding-bottom: var(--rc-theme-spacing-lg);
}

.spin-root {
  height: 100%;
}

.spin-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.empty .spin-container > :not(ul) {
  flex: 1;
}

.container {
  border-radius: var(--rc-theme-border-radius-lg);
}

.empty {
  --empty-table-header-height: 55px;
}

.empty .container,
.empty .content,
.empty .content table {
  height: 100%;
}

/* stylelint-disable-next-line at-rule-no-vendor-prefix -- prevents Firefox from stretching the table header when the table has height: 100%. Do not remove until Firefox fixes it. */
@-moz-document url-prefix() {
  .empty thead > tr {
    height: var(--empty-table-header-height);
  }
}

.body-row:last-child .body-cell:first-child {
  border-bottom-left-radius: var(--rc-theme-border-radius-lg);
}

.body-row:last-child .body-cell:last-child {
  border-bottom-right-radius: var(--rc-theme-border-radius-lg);
}

.pagination {
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  margin-block-start: var(--rc-theme-spacing-lg);
}

.pagination > :first-child {
  position: absolute;
  right: 105px;
}

.pagination > :last-child {
  position: relative;
  margin-left: auto;
}

.row-clickable {
  cursor: pointer;
}

.selection-column {
  cursor: default;
}

.header {
  margin-bottom: var(--rc-theme-spacing-lg);
}
